/**
 * User: konstantin
 * Date: 4/24/14
 */
$.namespace('scent');

scent.global = {
    isMobile: function() {
        return $(window).width() < 768;
    }
};


//////////////////
// WEBPACK FOOTER
// ./clientlibs/js/etc/designs/emagazine/clientlibs/publish/js/global.js
// module id = 31
// module chunks = 0